/**
 * @generated SignedSource<<c76081be729e6896c770a95d61b69801>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSidebarFavorites_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItem_item">;
  readonly " $fragmentType": "PdpSharedSidebarFavorites_item";
};
export type PdpSharedSidebarFavorites_item$key = {
  readonly " $data"?: PdpSharedSidebarFavorites_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSidebarFavorites_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSidebarFavorites_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "d028dec9b94ea01b28dc132a5de82b9d";

export default node;
